import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { fontText, StylesIndexInjections } from 'common-react';
import { flexCenter } from '../styles/mixins';

interface ErrorProcessPageStyleProps {
  layout: 'standard' | 'slim';
}

export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    ...flexCenter(),
    flexDirection: 'column',
    marginTop: ({ layout }: ErrorProcessPageStyleProps) => layout === 'slim' ? 0 : 60,
    [theme.breakpoints.down('xs')]: {
      alignItems: 'flex-start'
    },
    '& $title': {
      textAlign: 'center',
      [theme.breakpoints.down('xs')]: {
        textAlign: 'left'
      }
    },
  },

  title: {
    marginTop: 24,
  },

  infoText: {
    maxWidth: 720,
    margin: ({ layout }: ErrorProcessPageStyleProps) => layout === 'slim' ? '12px 0 18px' : '12px 0 36px',
    font: fontText('normal', theme.fontSize.l, 28),
    textAlign: 'center',
    color: theme.color.greys[50],
    [theme.breakpoints.down('xs')]: {
      textAlign: 'left'
    }
  },
  infoTextSmall: {
    font: fontText('normal', theme.fontSize.s, 28),
    color: theme.color.greys[80],
  },

  infoTextStrong: {
    font: fontText('normal', theme.fontSize.l, 28),
    color: theme.color.violets[50],
  },

  errorCode: {
    margin: ({ layout }: ErrorProcessPageStyleProps) => layout === 'slim' ? '24px 0 8px' : '34px 0 8px',
    overflowWrap: 'anywhere',
  },
  actionButtonWrapper: {
    pointerEvents: 'auto'
  },
  icon: {
    [theme.breakpoints.down('xs')]: {
      marginRight: 'auto'
    }
  }
}), { name: 'ErrorProcessPage', index: StylesIndexInjections.UI_MOLECULES });
